/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="82.5"
        viewBox="0 0 95.59 82.5"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M37.5 35.21a9.56 9.56 0 1 0 9.55 9.56 9.56 9.56 0 0 0-9.55-9.56Zm0 2.5a7.06 7.06 0 1 1-7.06 7.06 7.06 7.06 0 0 1 7.06-7.06ZM44.5 58.79a1.25 1.25 0 0 1 .13 2.49H29.31a6.61 6.61 0 0 0-6.61 6.39v1.4a1.25 1.25 0 0 1-2.49.13v-1.3a9.11 9.11 0 0 1 8.86-9.11H44.5ZM60.5 47.38a9.56 9.56 0 1 0 9.56 9.56 9.56 9.56 0 0 0-9.56-9.56Zm0 2.5a7.06 7.06 0 1 1-7 7.06 7.06 7.06 0 0 1 7-7.06ZM68.62 71a9.12 9.12 0 0 1 9.12 8.85v1.43a1.25 1.25 0 0 1-2.49.13v-1.3a6.62 6.62 0 0 0-6.39-6.61H52.33a6.62 6.62 0 0 0-6.62 6.38v1.4a1.25 1.25 0 0 1-2.49.13v-1.3A9.12 9.12 0 0 1 52.06 71h16.56ZM89.15 10H64.24a6.43 6.43 0 0 0-6.43 6.43V32.6a6.43 6.43 0 0 0 6.43 6.2h3.8v6a1.25 1.25 0 0 0 2 .84l8.07-6.85h11a6.46 6.46 0 0 0 6.43-6.43V16.47A6.43 6.43 0 0 0 89.15 10Zm-24.91 2.5h24.91a3.92 3.92 0 0 1 3.93 3.93v15.9a4 4 0 0 1-3.93 3.93h-11.6a1.27 1.27 0 0 0-.66.29L70.5 42v-4.45a1.25 1.25 0 0 0-1.25-1.25h-5.01a3.92 3.92 0 0 1-3.93-3.93v-15.9a3.92 3.92 0 0 1 3.93-3.93Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M84.93 26.7a2.14 2.14 0 1 0-2.14-2.13 2.13 2.13 0 0 0 2.14 2.13M76.7 26.7a2.14 2.14 0 1 0-2.14-2.13 2.13 2.13 0 0 0 2.14 2.13M68.5 26.7a2.14 2.14 0 1 0-2.13-2.13 2.13 2.13 0 0 0 2.13 2.13"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M31.34 0H6.43A6.43 6.43 0 0 0 0 6.43v16.13a6.47 6.47 0 0 0 6.43 6.2h11l8.07 6.85.1.07a1.25 1.25 0 0 0 2-1v-5.9h3.79a6.43 6.43 0 0 0 6.44-6.43V6.43A6.44 6.44 0 0 0 31.34 0ZM6.43 2.5h24.91a3.94 3.94 0 0 1 3.94 3.93v15.9a3.93 3.93 0 0 1-3.94 3.93h-5.17a1.25 1.25 0 0 0-1.12 1.24V32l-6.36-5.39a1.25 1.25 0 0 0-.81-.3H6.43a4 4 0 0 1-3.93-3.98V6.43A3.93 3.93 0 0 1 6.43 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M10.65 16.67a2.14 2.14 0 1 1 2.14-2.14 2.13 2.13 0 0 1-2.14 2.14M18.89 16.67a2.14 2.14 0 1 1 2.14-2.14 2.14 2.14 0 0 1-2.14 2.14M27.12 16.67a2.14 2.14 0 1 1 2.14-2.14 2.14 2.14 0 0 1-2.14 2.14"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleTwoWordBubblesIcon';

export default Icon;
